import banners from './modules/banners';
import announcements from './modules/announcements';
import merchants from './modules/merchants';
import courses from './modules/courses';
import categories from './modules/categories';
import sections from './modules/sections';
import faqs from './modules/faqs';

const initialState = {
  dataServer: {},
  previousPage: null,
  isAppLoading: false,
  isLoading: {
    highlightedMerchant: false,
    merchants: false,
    merchantDetail: false,
    courses: false,
    courseDetail: false,
    categories: false,
    categoriesConfig: false,
    filterConfig: false,
    closestCourseConfig: false,
    closestCourses: false,
  },
  isError: {
    highlightedMerchant: false,
    merchants: false,
    merchantDetail: false,
    courses: false,
    categories: false,
    categoriesConfig: false,
    filterConfig: false,
    closestCourseConfig: false,
    closestCourses: false,
  },
  snackbar: {
    isShown: false,
    isError: false,
    message: '',
  },
};

const getters = {
  isAppLoading: (state) => state.isAppLoading || Object.values(state.isLoading).some((isLoading) => isLoading),
  isLoadingCourses: (state) => state.isLoading.courses,
  isLoadingClosestCourses: (state) => state.isLoading.closestCourses,
  getPreviousPage: (state) => state.previousPage,
  getError: (state) => state.isError,
  getIsEnableLandingPageCategorySection: (state) => state.dataServer?.toggle?.isEnableLandingPageCategorySection,
  getSnackbar: (state) => state.snackbar,
  getToggleSegmentation: (state) => state.dataServer?.toggle?.toggleSegmentation,
  getCheckQuotaToggle: (state) => state.dataServer?.toggle?.isCheckQuotaActive,
  getRetryOtpToggle: (state) => state.dataServer?.toggle?.isRetryOtpActive,
  getNewPaymentPolicyToggle: (state) => state.dataServer?.toggle?.isEnableNewPaymentPolicy,
  getPurchasedVoucherToggle: (state) => state.dataServer?.toggle?.isEnablePurchasedVoucher,
};

const actions = {
  onSnackbarShow({commit}, {message = '', error = ''} = {}) {
    const payload = {
      isShown: true,
      isError: !!error,
      message: message || error,
    };
    commit('onSnackbarShow', payload);
  },
};
const mutations = {
  setDataServer(state, dataFromServer) {
    state.dataServer = dataFromServer;
  },
  setPreviousPage(state, previousPage) {
    state.previousPage = previousPage;
  },
  setLoading(state, loading) {
    state.isLoading = {...state.isLoading, ...loading};
  },
  setError(state, error) {
    state.isError = {...state.isError, ...error};
  },
  onSnackbarShow(state, payload) {
    state.snackbar = payload;
  },
  setAppLoading(state, isLoading) {
    state.isAppLoading = isLoading;
  },
  resetErrors(state) {
    state.isError = {
      highlightedMerchant: false,
      merchants: false,
      merchantDetail: false,
      courses: false,
      categories: false,
      categoriesConfig: false,
      filterConfig: false,
    };
  },
};

export default {
  state: {...initialState},
  getters,
  actions,
  mutations,
  modules: {
    banners,
    announcements,
    merchants,
    courses,
    categories,
    sections,
    faqs,
  },
};
